<template>
  <div
    class="bg-blue-500 shadow-md p-2 flex flex-row rounded-md max-w-lg mb-12
    justify-between"
  >
    <!-- BACKGROUND COLOR -->
    <back-ground-icon title="Background Color" @click="$emit('selected', { type: 'COLOR', rank: rank })" />
    <!-- IMAGE -->
    <image-icon title="Image" @click="$emit('selected', { type: 'IMAGE', rank: rank })"  />

    <!-- VIDEO -->
    <video-icon title="Video" @click="$emit('selected', { type: 'VIDEO', rank: rank })"/>
    <!-- TEXT -->
    <text-icon title="Text" @click="$emit('selected', { type: 'TEXT', rank: rank })" />

    <!-- TITLE -->
    <title-icon title="Title" @click="$emit('selected', { type: 'TITLE', rank: rank })"/>


    <!-- DATA CHART -->
    <chart-icon title="Data Chart" @click="$emit('selected', { type: 'CHART', rank: rank })"/>

    <!-- CHEVRONS -->
    <chevron-icon title="Vertical Space" @click="$emit('selected', { type: 'SPACE', rank: rank })"/>

    <audio-icon title="Audio" @click="$emit('selected', { type: 'AUDIO', rank: rank })"/>

    <!-- <svg -->
    <!--   xmlns="http://www.w3.org/2000/svg" -->
    <!--   fill="none" -->
    <!--   viewBox="0 0 24 24" -->
    <!--   stroke="currentColor" -->
    <!--   class="h&#45;8 w&#45;8 text&#45;blue&#45;100 hover:text&#45;white" -->
    <!--   v&#45;tooltip="'Content Trigger'" -->
    <!--   @click="$emit('selected', { type: 'TRIGGER', rank: rank })" -->
    <!-- > -->
    <!--   <path -->
    <!--     stroke&#45;linecap="round" -->
    <!--     stroke&#45;linejoin="round" -->
    <!--     stroke&#45;width="2" -->
    <!--     d="M13 10V3L4 14h7v7l9&#45;11h&#45;7z" -->
    <!--   /> -->
    <!-- </svg> -->
  </div>
</template>

<script>
import BackGroundIcon from '@/components/Icon/BackGroundIcon.vue'
import ImageIcon from '@/components/Icon/ImageIcon.vue'
import TextIcon from '@/components/Icon/TextIcon.vue'
import VideoIcon from '@/components/Icon/VideoIcon.vue'
import ChartIcon from '@/components/Icon/ChartIcon.vue'
import ChevronIcon from '@/components/Icon/ChevronIcon.vue'
import TitleIcon from '@/components/Icon/TitleIcon.vue'

import AudioIcon from '@/components/Icon/AudioIcon.vue'

export default {
  components: {
    BackGroundIcon,
    ImageIcon,
    TextIcon,
    VideoIcon,
    ChartIcon,
    ChevronIcon,
    TitleIcon,
    AudioIcon
  },

  props: { rank: { type: Number, default: -1 } },

  data() {
    return {};
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style></style>
